import { useEffect, useMemo, useState } from 'react'
import CollectService from '../../../services/api/CollectService'
import SummaryService from '../../../services/api/SummaryService'
import buildFormOptions from '../buildFormOptions'

const useSummaryFormData = (collectId, summaryId, { enabled = true } = {}) => {
  const [collect, setCollect] = useState(null)
  const [summary, setSummary] = useState(null)
  const [summaryOptions, setSummaryOptions] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!enabled || collect && (summary || summaryOptions))
      return

    const fetchSummaryData = () => {
      if (summaryId)
        return SummaryService.getSummary(collectId, summaryId).then(setSummary)
      return SummaryService.getFormOptions(collectId).then(setSummaryOptions)
    }

    Promise.all([
      CollectService.getCollectData(collectId).then(setCollect),
      fetchSummaryData()
    ]).catch(err => setError(err.message))
  }, [enabled, collectId, summaryId])

  const formOptions = useMemo(() => {
    if (!collect)
      return null
    const options = summary || summaryOptions
    if (!options)
      return null
    return buildFormOptions({ collect, summaryOptions: options })
  }, [collect, summary, summaryOptions])

  return { collect, summary, formOptions, error }
}

export default useSummaryFormData
